var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.149 1.957 15.88 18.396 9.837 14H.37zm-7.454 11.43 4.424 3.218 1.608-11.663zm4.779-8.41L9.743 13H3.63z",
  clipRule: "evenodd"
})));
export default SvgTelegram;